import { Dashboard, XMLUpload } from '@/components';

export const XmlUploadPage = () => (
  <Dashboard openLogIn>
    <XMLUpload />
  </Dashboard>
);
